import PropTypes from 'prop-types'

const SessionsIcon = ({ title }: any) => (
  <svg width={33} height={34} viewBox="0 0 33 34">
    <title>{title}</title>
    <g transform="translate(1 1.936)" strokeWidth={3}>
      <circle strokeLinecap="square" cx={15.5} cy={10.5} r={3} />
      <path
        d="M21.5 21.5v-1.983a2 2 0 00-.983-1.725c-.973-.575-2.659-1.292-5.017-1.292-2.388 0-4.064.713-5.026 1.288a1.998 1.998 0 00-.974 1.719V21.5h12z"
        strokeLinecap="square"
      />
      <circle strokeLinecap="square" cx={26.5} cy={5.5} r={3} />
      <path d="M30.2 12.5c.197.969.3 1.973.3 3 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 3.317 0 6.378 1.073 8.862 2.896" />
    </g>
  </svg>
)

SessionsIcon.displayName = 'SessionsIcon'

SessionsIcon.propTypes = {
  title: PropTypes.string
}

SessionsIcon.defaultProps = {
  title: 'Sessions'
}

export default SessionsIcon
